import { createActions } from 'redux-actions';

import { SET_LOADING, SET_LOADED } from '../constants/App';

export const { setLoading, setLoaded } = createActions(SET_LOADING, SET_LOADED);
